import React, { FC } from 'react'
import Button from '@bt-react/components/Button'
import { SlideDeck } from '../../../lib/slides/types'
import { stopSlides } from '../../../dataStore/actions/slides/slides'
import { useDispatch } from 'react-redux'
import apiGateway from '../../../services/apiGateway'

interface SlidesControlProps {
  slidesId: string | null
  talkId: string | undefined
  slidesDeck: SlideDeck
}

const SlidesControl: FC<SlidesControlProps> = ({ slidesId, talkId, slidesDeck }) => {
  const dispatch = useDispatch<any>()
  const handleClick = async () => {
    if (!slidesId || !talkId) return
    try {
      await apiGateway.markSlidesAsFailed(talkId, slidesId)
      dispatch(stopSlides())
    } catch (e) {
      console.log('An error occurred when trying to mark slides as failed: ', e)
    }
  }

  const slideInfo = <>
    <Button onClick={handleClick} text={'Remove Slides'} />
    <br />
    <br />
    {slidesDeck && <>
      <p><strong>File name: </strong> {slidesDeck.fileName}</p>
      <p><strong>Number of slides: </strong> {slidesDeck.numberOfSlides}</p>
      <p><strong>Slides ID: </strong> {slidesDeck.slidesId}</p>
    </>
    }
  </>

  return <>
    <h3>Slides Control</h3>
    <br />
    {slidesId ? slideInfo : <p>There is currently no slide deck uploaded</p>}
  </>
}

export default SlidesControl